var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgReturnArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 30,
  viewBox: "7 7 16 15"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M17.054 11h-6.538l2.341-2.42a.52.52 0 0 0 0-.716l-.683-.715a.467.467 0 0 0-.683 0l-4.35 4.506a.526.526 0 0 0 0 .716l4.322 4.481a.467.467 0 0 0 .683 0l.684-.718a.52.52 0 0 0 0-.715l-2.34-2.418h6.564c1.93 0 3.5 1.57 3.5 3.5s-1.57 3.5-3.5 3.5h-2c-.554 0-1 .447-1 1s.446 1 1 1h2a5.5 5.5 0 0 0 0-11"
})));
export default SvgReturnArrow;